export let ProductModalFieldsJSON = {
  "1720177249476-documentFile": {
    elementid: 1720177249476,
    elementtype: "documentFile",
    "display-fieldlabel": "Logo",
    "display-labelposition": "top",
    "database-label": "logo_media_id",
  },
  "1692363731639-customSelect": {
    elementid: 1692363731639,
    elementtype: "customSelect",
    "display-required": 1,
    "database-label": "status",
    "data-datasource": "customvalues",
    "data-customvalue": "ACTIVE#INACTIVE",
    "display-fieldlabel": "Status",
    "display-noofcolumns": "2",
    "display-labelposition": "top",
  },
  "1718962116335-radio": {
    elementid: 1718962116335,
    elementtype: "radio",
    "data-datasource": "customvalues",
    "data-customvalue": "Product#Service",
    "display-fieldlabel": "Product Type",
    "database-label": "product_type",
    "display-noofcolumns": "2",
    "display-labelposition": "top",
    "display-required": 1,
  },
  "1718962133203-customSelect": {
    elementid: 1718962133203,
    elementtype: "customSelect",
    "data-datasource": "customvalues",
    "data-customvalue": "Insurance#Medicolegal",
    "display-fieldlabel": "Product/Service Category",
    "database-label": "product_category",
    "display-noofcolumns": "2",
    "display-labelposition": "top",
    "display-placeholder": "Select",
    "display-required": 1,
  },
  "1718962139100-customSelect": {
    elementid: 1718962139100,
    elementtype: "customSelect",
    "data-datasource": "customvalues",
    "data-customvalue": "Subscription#One Time",
    "display-fieldlabel": "Product Plan",
    "database-label": "product_plan",
    "display-noofcolumns": "2",
    "display-labelposition": "top",
    "display-placeholder": "Select",
    "display-required": 1,
  },
  "1718962144133-customSelect": {
    elementid: 1718962144133,
    elementtype: "customSelect",
    "data-datasource": "customvalues",
    "data-customvalue":
      "Single Variant#Dynamic Variant#Attribute Based Variant",
    "display-fieldlabel": "Product Variant",
    "database-label": "product_attributes",
    "display-noofcolumns": "2",
    "display-labelposition": "top",
    "display-placeholder": "Select",
    "display-required": 1,
  },
  "1718962155999-customSelect": {
    elementid: 1718962155999,
    elementtype: "customSelect",
    "data-datasource": "customvalues",
    "data-customvalue": "Simple Subscription#Variant Subscription",
    "display-fieldlabel": "Subscription Type",
    "database-label": "subscription_type",
    "display-noofcolumns": "2",
    "display-labelposition": "top",
    "display-placeholder": "Select",
    "display-required": 1,
  },
  "1718962162916-number": {
    elementid: 1718962162916,
    elementtype: "number",
    "display-fieldlabel": "Regular Price",
    "display-labelposition": "top",
    "display-placeholder": "Enter",
    "database-label": "regular_price",
  },
  // "1718962167948-customSelect": {
  //   elementid: 1718962167948,
  //   elementtype: "customSelect",
  //   "data-datasource": "customvalues",
  //   "data-customvalue": "optionA#optionB#optionC#optionD",
  //   "display-fieldlabel": "Subscription Period",
  //   "display-noofcolumns": "2",
  //   "display-labelposition": "top",
  // },
  // "1718962167948-number": {
  //   elementid: 1718962167948,
  //   elementtype: "number",
  //   "display-fieldlabel": "Subscription Period",
  //   "display-placeholder": "Enter",
  //   "display-labelposition": "top",
  //   "database-label": "subscription_period",
  // },
  // "1718962191832-select": {
  //   elementid: 1718962191832,
  //   elementtype: "customSelect",
  //   "data-datasource": "customvalues",
  //   "data-customvalue": "optionA#optionB#optionC#optionD",
  //   "display-fieldlabel": "Renewal Grace Period",
  //   "display-noofcolumns": "2",
  //   "display-labelposition": "top",
  // },
  "1718962191832-number": {
    elementid: 1718962191832,
    elementtype: "number",
    "display-fieldlabel": "Renewal Grace Period",
    "display-placeholder": "Enter",
    "display-labelposition": "top",
    "database-label": "renewal_grace_period",
  },
  // "1718962217262-customSelect": {
  //   elementid: 1718962217262,
  //   elementtype: "customSelect",
  //   "data-datasource": "customvalues",
  //   "data-customvalue": "optionA#optionB#optionC#optionD",
  //   "display-fieldlabel": "Auto Renewal Period",
  //   "display-noofcolumns": "2",
  //   "display-labelposition": "top",
  // },
  "1718962217262-number": {
    elementid: 1718962217262,
    elementtype: "number",
    "display-fieldlabel": "Auto Renewal Period",
    "display-placeholder": "Enter",
    "display-labelposition": "top",
    "database-label": "auto_renewal_period",
  },
  "1718962081569-columns": {
    elementid: 1718962081569,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1718962084686-columns": {
    elementid: 1718962084686,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1718962087636-columns": {
    elementid: 1718962087636,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1718962093535-columns": {
    elementid: 1718962093535,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1718962097604-columns": {
    elementid: 1718962097604,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1718962211447-columns": {
    elementid: 1718962211447,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1718962070420-fieldset": {
    elementid: 1718962070420,
    elementtype: "fieldset",
    "display-fieldlabel": "Product Details",
  },
  "1718962074038-fieldset": {
    elementid: 1718962074038,
    elementtype: "fieldset",
    "display-fieldlabel": "Subscription Details",
  },
  "1718962149683-textarea": {
    elementid: 1718962149683,
    elementtype: "textarea",
    "display-rows": "3",
    "display-fieldlabel": "Product Description",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
    "database-label": "product_description",
    "display-placeholder": "Enter",
  },
  "1718962110151-textfield": {
    elementid: 1718962110151,
    elementtype: "textfield",
    "display-fieldlabel": "Product Name",
    "database-label": "name",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
    "display-placeholder": "Enter",
    "display-required": 1,
  },
  "1718962222345-textfield": {
    elementid: 1718962222345,
    elementtype: "textfield",
    "display-fieldlabel": "Renewal Reminder",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
    "database-label": "renewal_reminder",
    "display-placeholder": "Enter",
  },
};

export let SubscriptionModalFieldsJSON = {
  "1718962155999-customSelect": {
    elementid: 1718962155999,
    elementtype: "customSelect",
    "data-datasource": "customvalues",
    "data-customvalue": "Simple Subscription#Variant Subscription",
    "display-fieldlabel": "Subscription Type",
    "database-label": "subscription_type",
    "display-noofcolumns": "2",
    "display-labelposition": "top",
    "display-required": 1,
  },
  "1718962162916-number": {
    elementid: 1718962162916,
    elementtype: "number",
    "display-fieldlabel": "Regular Price",
    "display-labelposition": "top",
    "display-placeholder": "Enter",
    "database-label": "regular_price",
  },
  // "1718962167948-customSelect": {
  //   elementid: 1718962167948,
  //   elementtype: "customSelect",
  //   "data-datasource": "customvalues",
  //   "data-customvalue": "optionA#optionB#optionC#optionD",
  //   "display-fieldlabel": "Subscription Period",
  //   "display-noofcolumns": "2",
  //   "display-labelposition": "top",
  // },
  // "1718962167948-number": {
  //   elementid: 1718962167948,
  //   elementtype: "number",
  //   "display-fieldlabel": "Subscription Period",
  //   "display-placeholder": "Enter",
  //   "display-labelposition": "top",
  //   "database-label": "subscription_period",
  // },
  // "1718962191832-customSelect": {
  //   elementid: 1718962191832,
  //   elementtype: "customSelect",
  //   "data-datasource": "customvalues",
  //   "data-customvalue": "optionA#optionB#optionC#optionD",
  //   "display-fieldlabel": "Renewal Grace Period",
  //   "display-noofcolumns": "2",
  //   "display-labelposition": "top",
  // },
  "1718962191832-number": {
    elementid: 1718962191832,
    elementtype: "number",
    "display-fieldlabel": "Renewal Grace Period",
    "display-placeholder": "Enter",
    "display-labelposition": "top",
    "database-label": "renewal_grace_period",
  },
  // "1718962217262-customSelect": {
  //   elementid: 1718962217262,
  //   elementtype: "customSelect",
  //   "data-datasource": "customvalues",
  //   "data-customvalue": "optionA#optionB#optionC#optionD",
  //   "display-fieldlabel": "Auto Renewal Period",
  //   "display-noofcolumns": "2",
  //   "display-labelposition": "top",
  // },
  "1718962217262-number": {
    elementid: 1718962217262,
    elementtype: "number",
    "display-fieldlabel": "Auto Renewal Period",
    "display-placeholder": "Enter",
    "display-labelposition": "top",
    "database-label": "auto_renewal_period",
  },
  "1718962081569-columns": {
    elementid: 1718962081569,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1718962084686-columns": {
    elementid: 1718962084686,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1718962087636-columns": {
    elementid: 1718962087636,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1718962093535-columns": {
    elementid: 1718962093535,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1718962097604-columns": {
    elementid: 1718962097604,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1718962211447-columns": {
    elementid: 1718962211447,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1718962222345-textfield": {
    elementid: 1718962222345,
    elementtype: "textfield",
    "display-fieldlabel": "Renewal Reminder",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
    "database-label": "renewal_reminder",
    "display-placeholder": "Enter",
  },
};

export const UploadFieldsJSON = {
  "1717412405877-documentFile": {
    elementid: 1717412405877,
    elementtype: "documentFile",
    "display-fieldlabel": "Product Logo",
    "display-required": 0,
    "database-label": "logo_media_id",
    "display-labelposition": "top",
  },
};

export let VariantModalFieldsJSON = {
  "1718973262354-number": {
    elementid: 1718973262354,
    elementtype: "number",
    "display-fieldlabel": "Price",
    "display-labelposition": "top",
  },
  "1718973268920-customSelect": {
    elementid: 1718973268920,
    elementtype: "customSelect",
    "data-datasource": "customvalues",
    "data-customvalue": "optionA#optionB#optionC#optionD",
    "display-fieldlabel": "Status",
    "display-noofcolumns": "2",
    "display-placeholder": "Select",
    "display-labelposition": "top",
  },
  "1718973276453-customSelect": {
    elementid: 1718973276453,
    elementtype: "customSelect",
    "data-datasource": "customvalues",
    "data-customvalue": "optionA#optionB#optionC#optionD",
    "display-fieldlabel": "Product",
    "display-noofcolumns": "2",
    "display-placeholder": "Select",
    "display-labelposition": "top",
  },
  "1718973281553-customSelect": {
    elementid: 1718973281553,
    elementtype: "customSelect",
    "data-datasource": "customvalues",
    "data-customvalue": "optionA#optionB#optionC#optionD",
    "display-fieldlabel": "Subscription Period",
    "display-noofcolumns": "2",
    "display-placeholder": "Select",
    "display-labelposition": "top",
  },
  "1718973247438-columns": {
    elementid: 1718973247438,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1718973255355-textfield": {
    elementid: 1718973255355,
    elementtype: "textfield",
    "display-fieldlabel": "Name",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
  },
};
